import produce from 'immer';
import { ReducerAction } from 'store/modules/types';
import { Types, GerarRenachIntegrado } from './types';

export const INITIAL_STATE: GerarRenachIntegrado = {
	status: 0,
	data: null,
	dataError: null,
	requestData: null,
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerAction,
): GerarRenachIntegrado {
	return produce(state, draft => {
		switch (action.type) {
			case Types.GERAR_RENACH_INTEGRADO_REQUEST: {
				draft.status = 100;
				draft.data = INITIAL_STATE.data;
				draft.requestData = INITIAL_STATE.requestData;
				draft.dataError = INITIAL_STATE.dataError;
				break;
			}

			case Types.GERAR_RENACH_INTEGRADO_SUCCESS: {
				draft.data = action.payload.response.data;
				draft.status = action.payload.response.status;
				draft.requestData = action.payload.request;
				draft.dataError = INITIAL_STATE.dataError;
				break;
			}

			case Types.GERAR_RENACH_INTEGRADO_FAILURE: {
				draft.status = action.payload.response.data.status;
				draft.data = INITIAL_STATE.data;
				draft.dataError = action.payload.response.data.data;
				draft.requestData = action.payload.request;
				break;
			}

			case Types.GERAR_RENACH_INTEGRADO_CLEAR: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				draft.dataError = INITIAL_STATE.dataError;
				draft.requestData = INITIAL_STATE.requestData;
				break;
			}
			default:
		}
		return draft;
	});
}
